// Version : 0.0.1
// Author :
// LastEdit : 
// Last ADD : INITIAL CREATION
// MODIFIED DATE: 

import ThriftReportActionTypes from './thrift-report.types';

/** ***************** FETCH THRIFT REPORT START *********************** */
export const fetchThriftReportStart = (getData: any) => ({
	type: ThriftReportActionTypes.FETCH_THRIFT_REPORT_START,
	payload: getData,
});

export const fetchThriftReportSuccess = (successData: any) => ({
	type: ThriftReportActionTypes.FETCH_THRIFT_REPORT_SUCCESS,
	payload: successData,
});

export const fetchThriftReportFailure = (failureData: any) => ({
	type: ThriftReportActionTypes.FETCH_THRIFT_REPORT_FAILURE,
	payload: failureData,
});

export const fetchThriftReportResponseReset = () => ({
	type: ThriftReportActionTypes.FETCH_THRIFT_REPORT_RESPONSE_RESET,
});

export const fetchThriftReportResponseChanged = () => ({
	type: ThriftReportActionTypes.FETCH_THRIFT_REPORT_RESPONSE_CHANGED,
});
/** ***************** FETCH THRIFT REPORT END *********************** */

